import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const AndroidIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M17.6 16C20.4 14.4 22.6 13.2 22.8 13.1C23.4 12.8 24 11.9 22.8 11.3C22.4 11.1 20.3 9.9 17.6 8.4L13.9 12.2L17.6 16Z" fill={color} />
    <Path d="M13.9 12.2L1.9 24.5C2.2 24.5 2.5 24.4 2.9 24.2C3.7 23.8 12 19.2 17.6 16L13.9 12.2Z" fill={color} />
    <Path d="M13.9 12.2L17.6 8.4C17.6 8.4 3.7 0.7 2.9 0.2C2.6 0 2.2 0 1.9 0L13.9 12.2Z" fill={color} />
    <Path d="M13.9 12.2L1.9 0C1.4 0.1 1 0.6 1 1.5C1 2.9 1 21.8 1 23C1 23.9 1.3 24.4 1.9 24.5L13.9 12.2Z" fill={color} />
  </Svg>
);

AndroidIcon.displayName = 'AndroidIcon';
